import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const markNotificationRead = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${__API_URL__}/api/staff-notifications/${id}/mark-read/`,
    {},
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const useMarkNotificationReadMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markNotificationRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["staff-notifications"] });
      queryClient.invalidateQueries({ queryKey: ["staff-notifications-unread-count"] });
    },
  });
};

export default useMarkNotificationReadMutation;
